import {createResource, Permissible, Phone} from "./common"
import {Recipient} from "../components/AccountCards/CustomerOutreachModal/CustomerOutreachModal"

export enum CardActionType {
	Activate = "Activate",
	Freeze = "Freeze",
	Unfreeze = "Unfreeze",
	Report = "Report",
	Close = "Close",
	Replace = "Replace",
	ManagePin = "ManagePin",
	Reactivate = "Reactivate",
}

export enum RecipientsType {
	sms = "sms",
	email = "email",
}

export enum SendLinkType {
	sendLinkForCardActionComponent = "sendLinkForCardActionComponent",
}

export type SendLink = SendLinkForCardAction

export type SendLinkForCardAction = {
	id: string
	type: SendLinkType.sendLinkForCardActionComponent
	attributes: {
		cardActionType: CardActionType
		recipients: [
			{
				type: RecipientsType.sms
				attributes: {
					phone: Permissible<Phone>
				}
			},
			{
				type: RecipientsType.email
				attributes: {
					email: Permissible<string>
				}
			}
		]
	}
	relationships: {
		card: {
			data: {
				type: string
				id: string
			}
		}
		whiteLabelTheme?: {
			data: {
				type: string
				id: string
			}
		}
		whiteLabelLanguage?: {
			data: {
				type: string
				id: string
			}
		}
	}
}

export interface SendLinkRequest {
	accessToken: string
	idempotencyKey: string
	recipient: Recipient
	cardActionType: CardActionType
	cardId: string
}

export async function sendLinkForCardAction(request: SendLinkRequest) {
	const data = {
		type: SendLinkType.sendLinkForCardActionComponent,
		attributes: {
			idempotencyKey: request.idempotencyKey,
			cardActionType: request.cardActionType,
			recipients: [
				{
					type: request.recipient.type,
					attributes: {
						[request.recipient.key]: request.recipient.value,
					},
				},
			],
		},
		relationships: {
			card: {
				data: {
					type: "card",
					id: request.cardId,
				},
			},
		},
	}
	return await createResource<SendLink>("white-label/send-link", request.accessToken, data)
}
